import { font, oPopupPadding, Popup } from '@approvalmax/ui';
import { AlertListIcon } from 'modules/sprites';
import styled from 'styled-components';

export const DefaultContent = styled(Popup.DefaultContent)`
    position: relative;
    width: 620px;
    max-height: 400px;
`;

export const Content = styled.div`
    ${oPopupPadding()}
`;

export const Description = styled.div`
    ${font(12)}
`;

export const TableContainer = styled.div`
    overflow-y: auto;
    max-height: 140px;
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: end;
    margin-top: 30px;
    gap: 20px;
`;

export const StyledAlertListIcon = styled(AlertListIcon)`
    color: #cb4e30;
    width: 12px;
    height: 12px;
    margin-top: 3px;
`;

export const DiscrepancyContainer = styled.div`
    display: flex;
    gap: 5px;
`;

export const DiscrepancyName = styled.div`
    ${font(12)};
    &:before {
        content: '-';
        margin-right: 3px;
    }
`;
